const API = { url: "http://192.168.31.10:2333", ws: "ws://192.168.31.10:2333" };

const API_PRODUCTION = {
  url: `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
  ws: `${window.location.protocol === "https:" ? "wss" : "ws"}:${window.location.hostname}:${window.location.port}`,
};
console.log("protocal:" + window.location.protocol);
console.log("location: " + window.location.hostname);
console.log("ENV:" + process.env.REACT_APP_ENV);

export default process.env.REACT_APP_ENV === "DEV" ? API : API_PRODUCTION;
